import React from 'react';
import { Container } from 'react-bootstrap';
import { Database } from 'lucide-react';

const Header = () => {
    return (
        <div className="bg-card border-b border-border shadow-sm">
            <Container className="max-w-7xl mx-auto px-6 py-4">
                <h1 className="text-3xl font-bold text-foreground d-flex align-items-center">
                    <Database className="w-8 h-8 text-primary me-3" />
                    Indexing Control Panel
                </h1>
            </Container>
        </div>
    );
};

export default Header;
